export default "__VITE_ASSET__Cqix_mRR__"